import { SELECTORS } from './constants';
import { splitProductIds } from './helpers';

const getReviewsContainer = () => document.querySelector(`.${SELECTORS.REVIEWS}`);

const getProductId = () => getReviewsContainer()?.dataset?.productId;

const getAllProducts = () => splitProductIds(getReviewsContainer()?.dataset?.allProducts);

export default { getProductId, getAllProducts };
